import { render, staticRenderFns } from "./StudentAddress.vue?vue&type=template&id=16b3a52f"
import script from "./StudentAddress.vue?vue&type=script&lang=js"
export * from "./StudentAddress.vue?vue&type=script&lang=js"
import style0 from "./StudentAddress.vue?vue&type=style&index=0&id=16b3a52f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports